<template>
    <div class="ui-kit">
        <div class="color-wrap">
            <h2 class="title-block">Colors</h2>
            <div class="colors">
                <div class="main-color">E2173D</div>
                <div class="secondary-color">44B69E</div>
                <div class="color-info">84A45D</div>
                <div class="color-green">559A2B</div>
                <div class="color-processing">2755CF</div>
                <br>
                <div class="accent-color-dark">000000</div>
                <div class="font-color">4A4A4A</div>
                <div class="additional-color-dark">818190</div>
                <div class="grey">9B9B9B</div>
                <div class="color-disabled">E5E5E5</div>
                <div class="additional-color-light">F9F9F9</div>
                <div class="accent-color-light">FFFFFF</div>
            </div>
        </div>
        <div class="labels-wrap">
            <h2 class="title-block">Labels</h2>
            <div class="labels">
                <v-layout row xs8 wrap>
                    <v-layout column xs4 wrap>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=false bg_color="#44B69E" class="mr-5">{{$t("Новости")}}</label-topic>
                            <label-topic :small=false bg_color="#000000">{{$t("Online-мероприятия")}}</label-topic>
                        </v-layout>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=false bg_color="#E2173D" class="mr-5">{{$t("Маркетинговые акции")}}</label-topic>
                            <label-topic :small=false bg_color="#2755cf">{{$t("Идеи")}}</label-topic>
                        </v-layout>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=false bg_color="#9b9b9b" class="mr-5">{{$t("Offline-мероприятие")}}</label-topic>
                            <label-topic :small=false bg_color="#559a2b">{{$t("База знаний")}}</label-topic>
                        </v-layout>
                    </v-layout>
                    <v-layout column xs4 wrap>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=true bg_color="#ffffff" class="mr-5"
                                         style="box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);"
                            >{{ $t("Идет обучение") }}</label-topic>
                            <label-topic :small=false bg_color="#c61536">{{$t("Обязательный курс")}}</label-topic>
                        </v-layout>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=true bg_color="#44b69e" class="mr-5">{{$t("Новый")}}</label-topic>
                            <label-topic :small=false bg_color="#9b9b9b">{{$t("Необязательный курс")}}</label-topic>
                        </v-layout>
                        <v-layout row wrap class="mb-4">
                            <label-topic :small=true bg_color="#9b9b9b">{{$t("Завершен")}}</label-topic>
                        </v-layout>
                    </v-layout>
                </v-layout>
            </div>
        </div>
        <div class="heading-wrap">
            <h2 class="title-block">heading</h2>
            <div class="heading">
                <h1 class="mb-4 mt-4">H1. <br>
                    FuturisC Normal, 78px</h1>
                <hr>
                <h2 class="mb-4 mt-4">H2. <br>
                    FuturaFuturisLightC (uppercase), 44px</h2>
                <hr>
                <h3 class="mb-4 mt-4">H3. <br>
                    FuturaFuturisLightC, 36px</h3>
                <hr>
                <h4 class="mb-4 mt-4">H4. <br>
                    FuturaFuturisLightC, 24px</h4>
                <hr>
                <h5 class="mb-4 mt-4">H5. <br>
                    FuturaFuturisLightC, 20px</h5>
                <hr>
                <h6 class="mt-4">H6. <br>
                    FuturaFuturisLightC, 15px</h6>
            </div>
        </div>
        <div class="type-wrap">
            <h2 class="title-block">type</h2>
            <div class="type">

            </div>
        </div>
        <div class="links-wrap paddings">
            <h2 class="title-block">links</h2>
            <v-layout row>
                <v-flex xs1 />
                <v-flex xs2>
                    inside text
                </v-flex>
                <v-flex xs1>
                    link #1
                </v-flex>
                <v-flex xs1>
                    link #2
                </v-flex>
                <v-flex xs1>
                    link #3
                </v-flex>
                <v-flex xs2 class="dark-bg">
                    link #4
                </v-flex>
                <v-flex xs2>
                    link with icon
                </v-flex>
                <v-flex xs1 />
            </v-layout>
            <v-layout row>
                <v-flex xs1>
                    normal
                </v-flex>
                <v-flex xs2>
                    <light-link :href="url">linking link linkous</light-link>
                </v-flex>
                <v-flex xs1>
                    <red-link :href="url">linking link linkous</red-link>
                </v-flex>
                <v-flex xs1>
                    <green-link :href="url">linking link linkous</green-link>
                </v-flex>
                <v-flex xs1>
                    <dark-link :href="url">linking link linkous</dark-link>
                </v-flex>
                <v-flex xs2 class="dark-bg">
                    <white-link :href="url">linking link linkous</white-link>
                </v-flex>
                <v-flex xs2>
                    <icon-link :href="url" :icon="'bell'">linking link linkous</icon-link>
                </v-flex>
                <v-flex xs1>
                    normal
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs1>
                    hover
                </v-flex>
                <v-flex xs2>
                    <light-link :href="'url'">linking link linkous</light-link>
                </v-flex>
                <v-flex xs1>
                    <red-link :href="'url'">linking link linkous</red-link>
                </v-flex>
                <v-flex xs1>
                    <green-link :href="'url'">linking link linkous</green-link>
                </v-flex>
                <v-flex xs1>

                    <dark-link :href="'url'">linking link linkous</dark-link>
                </v-flex>
                <v-flex xs2 class="dark-bg">
                    <white-link :href="'url'">linking link linkous</white-link>
                </v-flex>
                <v-flex xs2>
                    <icon-link :href="'url'" :icon="'bell'">linking link linkous</icon-link>
                </v-flex>
                <v-flex xs1>
                    hover
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs1>
                    disabled
                </v-flex>
                <v-flex xs2>
                    <light-link :href="url" :disable="true">linking link linkous</light-link>
                </v-flex>
                <v-flex xs1>
                    <red-link :href="url">linking link linkous</red-link>
                </v-flex>
                <v-flex xs1>
                    <green-link :href="url">linking link linkous</green-link>
                </v-flex>
                <v-flex xs1>
                    <dark-link :href="url">linking link linkous</dark-link>
                </v-flex>
                <v-flex xs2 class="dark-bg">
                    <white-link :href="url">linking link linkous</white-link>
                </v-flex>
                <v-flex xs2>
                    <icon-link :href="url" :icon="'bell'">linking link linkous</icon-link>
                </v-flex>
                <v-flex xs1>
                    disabled
                </v-flex>
            </v-layout>
        </div>
        <div class="buttons-wrap paddings">
            <h2 class="title-block">buttons</h2>
            <div class="buttons">
                <v-layout column>
                    <v-layout row>
                        <v-flex xs1>
                            normal
                        </v-flex>
                        <v-flex xs2>
                            <button-red>{{$t("Предложить идею")}}</button-red>
                        </v-flex>
                        <v-flex xs2>
                            <button-bd-white>{{$t("Предложить идею")}}</button-bd-white>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-transparent>{{$t("Обратная связь")}}</button-transparent>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-white>{{$t("Предложить идею")}}</button-white>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs1>
                            hover
                        </v-flex>
                        <v-flex xs2>
                            <button-bd-white>{{$t("Предложить идею")}}</button-bd-white>
                        </v-flex>
                        <v-flex xs2>
                            <button-red>{{$t("Предложить идею")}}</button-red>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-red>{{$t("Обратная связь")}}</button-red>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-transparent>{{$t("Предложить идею")}}</button-transparent>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs1>
                            disabled
                        </v-flex>
                        <v-flex xs2>
                            <button-red disabled="true">{{$t("Предложить идею")}}</button-red>
                        </v-flex>
                        <v-flex xs2>
                            <button-bd-white disabled="true">{{$t("Предложить идею")}}</button-bd-white>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-transparent disabled="true">{{$t("Обратная связь")}}</button-transparent>
                        </v-flex>
                        <v-flex xs2 class="dark-bg">
                            <button-white disabled="true">{{$t("Предложить идею")}}</button-white>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <hr>
                <v-layout column>
                    <v-layout row>
                        <v-flex xs1>
                            normal
                        </v-flex>
                        <v-flex xs2>
                            <close-button icon_name="close" />
                        </v-flex>
                        <v-flex xs1>
                            <plus-button icon_name="plus" />
                        </v-flex>
                        <v-flex xs1>
                            <minus-button icon_name="minus" />
                        </v-flex>
                        <v-flex xs1>
                            <slider-nav icon_name="arrow-left" />
                        </v-flex>
                        <v-flex xs1>
                            <slider-nav icon_name="arrow-right" />
                        </v-flex>
                    </v-layout>
                </v-layout>
                <hr>
                <v-layout column>
                    <v-layout row>
                        <v-flex xs1>
                            normal
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='right' :text="$t('Международные классификации')" icon_name='icon-list' />
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='right' :text="$t('Продуктовый портфель')" icon_name='portfolio'
                                        class="db-portfolio"
                            />
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='right' :text="$t('Одобрения ОЕМ')" icon_name='approval'
                                        class="db-approval"
                            />
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='right' :text="$t('Справочник')" icon_name='info'
                                        class="db-info"
                            />
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='top' :text="$t('Повысить рейтинг')" icon_name='rating'
                                        class="rating-raise"
                            />
                        </v-flex>
                        <v-flex>
                            <CardBgIcon type='top' :text="$t('Все рейтинги')" icon_name='arrow-right'
                                        class="rating-all"
                            />
                        </v-flex>
                    </v-layout>
                </v-layout>
                <v-layout row>
                    <v-flex xs1>
                        <icon-with-label icon_name="heart" class="icon-label-red">112</icon-with-label>
                    </v-flex>
                    <v-flex xs1>
                        <icon-with-label icon_name="chat" class="icon-label-green">75</icon-with-label>
                    </v-flex>
                    <v-flex xs1 class="dark-bg">
                        <icon-with-label icon_name="heart" class="icon-label-white">112</icon-with-label>
                    </v-flex>
                    <v-flex xs1 class="dark-bg">
                        <icon-with-label icon_name="chat" class="icon-label-white">75</icon-with-label>
                    </v-flex>
                    <v-flex xs2>
                        <icon-with-label icon_name="favorites" class="icon-label-grey">{{$t("В избранное")}}</icon-with-label>
                    </v-flex>
                    <v-flex xs2>
                        <icon-with-label icon_name="favorites" class="icon-label-red">{{$t("В избранном")}}</icon-with-label>
                    </v-flex>
                </v-layout>
            </div>
        </div>
        <div class="checkbox-wrap">
            <h2 class="title-block">checkbox</h2>
            <div class="checkbox">
                <v-flex xs2>
                    <checkbox id="ch1" name="check1">Type something</checkbox>
                </v-flex>
                <v-flex xs2>
                    <checkbox id="ch2" name="check2" :error="true">Type something</checkbox>
                </v-flex>
                <v-flex xs2>
                    <checkbox id="ch3" name="check3" :disabled="true">Type something</checkbox>
                </v-flex>
            </div>
        </div>
        <div class="radio-wrap">
            <h2 class="title-block">radiobutton</h2>
            <div class="radiobutton">
                <v-radio-group row>
                    <v-radio
                        :label="`Radio 1`"
                        :value="1"
                        :color="'#44b69e'"
                    />
                    <v-radio
                        :label="`Radio 2`"
                        :value="2"
                        :error="true"
                    />
                    <v-radio
                        :label="`Radio 3`"
                        :value="3"
                        :disabled="true"
                    />
                </v-radio-group>
            </div>
        </div>
        <div class="pagination-wrap">
            <h2 class="title-block">pagination</h2>
            <div class="pagination">
                <div class="text-xs-center">
                    <v-pagination
                        v-model="page"
                        :length="14"
                        :total-visible="7"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </div>
        </div>
        <div class="switcher-wrap">
            <h2 class="title-block">switcher</h2>
            <v-layout column wrap>
                <v-flex xs12 sm6 md4>
                    <div class="switcher">
                        <v-switch
                            :label="$t(`Push-уведомления`)"
                        />
                    </div>
                </v-flex>
                <v-flex>
                    <div class="switcher">
                        <v-switch
                            :label="$t(`Email-оповещения`)"
                        />
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <div class="inputs-wrap">
            <h2 class="title-block">input</h2>
            <div class="inputs">
                <v-layout row>
                    <v-flex sm4 md4>
                        <base-input :placeholder="$t('Введите e-mail')" />
                    </v-flex>
                    <v-flex sm4 md4
                            class="ml-3"
                    >
                        <base-input :placeholder="$t('Введите e-mail')" :error="true" />
                    </v-flex>
                    <v-flex sm4 md4
                            class="ml-3"
                    >
                        <base-input :placeholder="$t('Введите e-mail')" :disabled="true" />
                    </v-flex>
                </v-layout>
            </div>
        </div>
        <div class="select-wrap">
            <h2 class="title-block">select</h2>
            <v-flex xs12 sm6 d-flex>
                <v-app>
                    <v-flex xs12 sm6>
                        <v-select
                            :items="items"
                            solo
                            append-icon=""
                            :label="$t('Сделайте выбор')"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>

                        <v-select
                            :items="items"
                            solo
                            append-icon=""
                            placeholder="$t('Сделайте выбор')"
                            :error="true"
                            :error-messages="$t('Необходимо сделать выбор')"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <h2 class="title-block">multiselect</h2>
                        <v-select
                            v-model="value"
                            ref='closeMulti'
                            :items="items"
                            solo
                            append-icon=""
                            multiple
                        >
                            <template #append>
                              <v-icon aria-hidden="true" translate="no">
                                add
                              </v-icon>
                            </template>
                            <template
                                slot-scope="{ item, index }"
                                slot="selection"
                            >
                                <v-chip v-if="value.length === 1">
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text pl-3"
                                >{{$t("Выбрано курсов")}}: {{ value.length }} </span>
                            </template>
                            <v-list-tile
                                slot="prepend-item"
                                class="multiselect-header"
                            >
                                <input type="text" class="input" :placeholder="$t('Выберите материалы')"> <span @click="hideMulti">OK</span>
                            </v-list-tile>
                            <!-- <v-list-tile-content slot-scope="data" v-for="(item, i) in items" slot="item"
                                                 :key="i"
                            >
                                <v-list-tile-title v-html="data.item.text" />
                                <v-list-tile-action v-if="item.selected">
                                    <v-icon>check</v-icon>
                                </v-list-tile-action>
                            </v-list-tile-content> -->
                        </v-select>

                        <!-- <v-select
                            v-model="value"
                            ref='closeMulti'
                            :items="items"
                            solo
                            append-icon="add"
                            multiple
                            :error="true"
                            :error-messages="$t('Необходимо сделать выбор')"
                        >
                            <template
                                slot-scope="{ item, index }"
                                slot="selection"
                            >
                                <v-chip v-if="value.length === 1">
                                    <span>{{ item.title }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text pl-3"
                                >{{$t("Выбрано курсов")}}: {{ value.length }} </span>
                            </template>
                            <v-list-tile
                                slot="prepend-item"
                                class="multiselect-header"
                                :menu-props="{ 'closeOnContentClick':true }"
                            >
                                <input type="text" class="input" :placeholder="$t('Выберите материалы')"> <span @click="hideMulti">OK</span>
                            </v-list-tile>

                        </v-select> -->

                    </v-flex>
                </v-app>
            </v-flex>
            <!-- <div class="select">
                <v-layout row>
                    <v-flex sm6 md4>
                        <base-select />
                    </v-flex>
                    <v-flex sm6 md4
                            class="ml-3"
                    >
                        <base-select :error="true" />
                    </v-flex>
                </v-layout>
            </div> -->

        </div>
        <div class="calendar-wrap">
            <h2 class="title-block">calendar</h2>
            <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                    <div class="calendar">
                        <datepicker />
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <div class="multiselect-wrap">
            <!-- <h2 class="title-block">multiselect</h2> -->

            <!-- <div class="multiselect">
                <multiselect
                    v-model="value"
                    id="example"
                    :options="options"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :preserve-search="true"
                    placeholder="Pick some"
                    label="name"
                    track-by="name"
                    :preselect-first="true"
                    :multiple="true"
                    @select="onSelect"
                />
            </div> -->
        </div>
        <div class="search-wrap">
            <h2 class="title-block">search</h2>
            <div class="search">
                <input-icon icon_name="search" icon_green="true" />
            </div>
        </div>

    </div>

</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import {link_red, link_dark, link_green, link_white, link_light, link_icon} from '@/components/ui/links/base_links.js';
import {button_red, button_white, button_transparent, button_bd_white} from '@/components/ui/buttons/base_buttons.js';
import CardBgIcon from '@/components/ui/buttons/card_bg_icon/card_bg_icon_wrapper.vue';
import {minus_button, round_button, close_button, slider_nav} from '@/components/ui/buttons/buttons_icon/button_icons.js';
import IconWithLabel from '@/components/ui/icons/icon_with_label.vue';
import {base_input, base_checkbox} from '@/components/ui/inputs/base/base_inputs.js';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import input_icon from '@/components/ui/inputs/typed/input_icon.vue';
export default {
  name      : 'UIKit',
  components: {
    'label-topic'       : labelTopic,
    'red-link'          : link_red,
    'dark-link'         : link_dark,
    'green-link'        : link_green,
    'white-link'        : link_white,
    'light-link'        : link_light,
    'icon-link'         : link_icon,
    'button-red'        : button_red,
    'button-white'      : button_white,
    'button-transparent': button_transparent,
    'button-bd-white'   : button_bd_white,
    CardBgIcon,
    'close-button'      : close_button,
    'plus-button'       : round_button,
    'minus-button'      : minus_button,
    'slider-nav'        : slider_nav,
    IconWithLabel,
    'base-input'        : base_input,
    'checkbox'          : base_checkbox,
    datepicker,
    'input-icon'        : input_icon,
  },
  props: {
    url: {
      type   : String,
      default: 'http://yandex.ru',
    },
    disable: {
      type: Boolean,
    },
  },
  data: () => ({
    date         : null,
    menu         : false,
    modal        : false,
    menu2        : false,
    value        : null,
    dateFormatted: null,
    options      : [
      {name: 'Vue.js', language: 'JavaScript'},
      {name: 'Rails', language: 'Ruby'},
      {name: 'Sinatra', language: 'Ruby'},
      {name: 'Laravel', language: 'PHP', $isDisabled: true},
    ],
    items: [
      {text: 'Foo', selected: false},
      {text: 'Bar', selected: true},
      {text: 'Fizz', selected: false},
      {text: 'Buzz', selected: false},
    ],
    page: 1,

  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}-${day}-${year}`;
    },
    hideMulti() {
      this.$refs.closeMulti.blur();
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatHeaderDate(date) {
      const [year, month, day] = date.split('-');
      let months = {
        '01': 'Январь',
        '1' : 'Январь',
        '02': 'Февраль',
        '2' : 'Февраль',
        '03': 'Март',
        '3' : 'Март',
        '04': 'Апрель',
        '05': 'Май',
        '06': 'Июнь',
        '07': 'Июль',
        '08': 'Август',
        '09': 'Сентябрь',
        '10': 'Октябрь',
        '11': 'Ноябрь',
        '12': 'Декабрь',
      };
      return months[month] + ' '+ year;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "./../less/variables.less";

.ui-kit {
    width: 100%;
    height: 100%;
    padding: 100px;
    &>div {
        width: 100%;
        margin-bottom: 30px;
    }
    h2.title-block {
        font-size: 45px;
        color: @font-color;
        margin-bottom: 40px;
        text-transform: capitalize;
    }
    .colors div {
        width: 58px;
        height: 58px;
        border-radius: 50%;
        margin-right: 60px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: @accent-color-light;
        margin-bottom: 60px;
    }
    .main-color {
        background-color: @main-color;
    }
    .secondary-color {
        background-color: @secondary-color;
    }
    .color-info {
        background-color: @color-info;
    }
    .color-green {
        background-color: @color-green;
    }
    .color-processing {
        background-color: @color-processing;
    }
    .accent-color-dark {
        background-color: @accent-color-dark;
    }
    .font-color {
        background-color: @font-color;
    }
    .additional-color-dark {
        background-color: @additional-color-dark;
    }
    .grey {
        background-color: @grey;
    }
    div.color-disabled {
        background-color: @color-disabled;
        color: @accent-color-dark;
    }
    div.additional-color-light {
        background-color: @additional-color-light;
        color: @accent-color-dark;
    }
    div.accent-color-light {
        background-color: @accent-color-light;
        box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.2);
        color: @accent-color-dark;
    }
    h1 {
        font-size: 78px;
    }
    h2 {
        font-size: 44px;
    }
    h3 {
        font-size: 36px;
    }
    h4 {
        font-size: 24px;
    }
    h5 {
        font-size: 20px;
    }
    h6 {
        font-size: 15px;
    }
    .dark-bg {
        background-color: @font-color;
        color: @accent-color-light;
    }
    .paddings .layout .flex {
        padding: 10px;
    }
}
</style>
